module.exports = __webpack_public_path__ + "assets/img/wjxd2.6aefec29.jpg";